// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardBodyRelay = require("./PropertyWizardBodyRelay.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
var PropertyWizardRelay_serverDraft_graphql = require("../../../__generated__/PropertyWizardRelay_serverDraft_graphql.bs.js");

var convertFragment = PropertyWizardRelay_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelay_serverDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelay_serverDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelay_serverDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelay_serverDraft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay(props) {
  var formReady = PropertyWizardFormRelay.useInitForm(props.draftData, props.draftDbId, undefined);
  if (formReady) {
    return JsxRuntime.jsx(PropertyWizardBodyRelay.make, {});
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
                      children: JsxRuntime.jsx(PropertyWizardFormRelay__Elements.LoadingSpinner.make, {})
                    }),
                className: "flex-1"
              });
  }
}

var FormElements;

var make = PropertyWizardRelay;

exports.FormElements = FormElements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* MarkupHelpers Not a pure module */
